import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input, Select, Button, showToast } from '../components/UI';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', companyName: '', contactPhone: '', role: 'buyer', businessLicenseNumber: '' });
  const [loading, setLoading] = useState(false);

  const update = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = { ...form };
      if (data.role === 'buyer') delete data.businessLicenseNumber;
      const result = await register(data);
      showToast(`Welcome to R2 Markets, ${result.user.companyName}!`);
      navigate('/');
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 70px)', padding: 32 }}>
      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 40, maxWidth: 520, width: '100%' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--text)', fontFamily: 'var(--sans)', marginBottom: 8, letterSpacing: '-0.02em' }}>Create an account</h1>
        <p style={{ fontSize: 14, color: 'var(--text3)', marginBottom: 32 }}>Join the R2-certified electronics marketplace.</p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Select label="I am a" value={form.role} onChange={update('role')} required>
            <option value="buyer">Buyer (R2 Certified)</option>
            <option value="seller">Seller</option>
          </Select>

          <Input label="Company Name" value={form.companyName} onChange={update('companyName')} placeholder="Acme Recyclers LLC" required />
          <Input label="Email" type="email" value={form.email} onChange={update('email')} placeholder="ops@acmerecyclers.com" required />
          <Input label="Password" type="password" value={form.password} onChange={update('password')} placeholder="Min 8 characters" required />
          <Input label="Phone" value={form.contactPhone} onChange={update('contactPhone')} placeholder="+1 (555) 000-0000" />

          {form.role === 'seller' && (
            <Input label="Business License #" value={form.businessLicenseNumber} onChange={update('businessLicenseNumber')} placeholder="BL-2024-XXXXXX" mono />
          )}

          {form.role === 'buyer' && (
            <div style={{
              background: 'var(--accent-dim2)', border: '1px solid rgba(34,214,122,0.15)', borderRadius: 'var(--radius)',
              padding: 14, fontSize: 12, color: 'var(--text2)', fontFamily: 'var(--mono)', lineHeight: 1.6,
            }}>
              R2 certification is required for all buyers. After registration, you can upload your certificate from your dashboard. Certificates are verified before marketplace access is granted.
            </div>
          )}

          {form.role === 'seller' && (
            <div style={{
              background: 'var(--blue-dim)', border: '1px solid rgba(59,130,246,0.15)', borderRadius: 'var(--radius)',
              padding: 14, fontSize: 12, color: 'var(--text2)', fontFamily: 'var(--mono)', lineHeight: 1.6,
            }}>
              Your business credentials will be verified within 1–2 business days before listings can go live.
            </div>
          )}

          <Button type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            {loading ? 'Creating account...' : 'Create Account →'}
          </Button>
        </form>

        <div style={{ marginTop: 24, textAlign: 'center', fontSize: 14, color: 'var(--text3)' }}>
          Already have an account? <Link to="/login" style={{ color: 'var(--accent)', fontWeight: 500 }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
